import { RefObject } from "react";
import useForm from "../../../../../custom-hooks/form/useForm";
import useFormWarning from "../../../../../custom-hooks/form/useFormWarning";
import useInputChangeHandler from "../../../../../custom-hooks/form/handlers/useInputChangeHandler";
import useCheckboxChangeHandler from "../../../../../custom-hooks/form/handlers/useCheckboxChangeHandler";
import useSelectChangeHandler from "../../../../../custom-hooks/form/handlers/useSelectChangeHandler";
import { defaultValues } from "../../../../../app_constants";
import { PredefinedParams } from "../../../../../components/slidingpanel/type";
type UseSubnetCreateFormProps = {
  nameRef: RefObject<HTMLElement>;
  regionRef: RefObject<HTMLElement>;
  networkRef: RefObject<HTMLElement>;
  predefined_params?: PredefinedParams;
};

const useSubnetCreateForm = ({
  nameRef,
  regionRef,
  networkRef,
  predefined_params,
}: UseSubnetCreateFormProps) => {
  const { formWarning, showFormWarning, hideFormWarning } = useFormWarning();

  const { formData, error, handleChange } = useForm({
    validations: [
      {
        field: "name",
        requiredMessage: "Please enter a name for your network.",
        ref: nameRef,
      },
      {
        field: "region",
        requiredMessage: "Please select a region.",
        ref: regionRef,
      },
      {
        field: "selectedNetwork",
        requiredMessage: "Please select a network.",
        ref: networkRef,
      },
    ],
    initialState: {
      ipVersion: defaultValues.subnet.ip_version[0],
      region: predefined_params?.region || "",
    },
  });

  const handleInputChange = useInputChangeHandler({
    handleChange,
    hideFormWarning,
  });
  const handleCheckboxChange = useCheckboxChangeHandler({
    handleChange,
    hideFormWarning,
  });
  const handleSelectChange = useSelectChangeHandler({
    handleChange,
    hideFormWarning,
  });

  return {
    formWarning,
    showFormWarning,
    error,
    formData,
    handleInputChange,
    handleSelectChange,
    handleCheckboxChange,
  };
};

export default useSubnetCreateForm;
